import { Container } from "../../Container/Container/Container";
import styles from "./IngredientsCard.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var IngredientsCard = function IngredientsCard(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx("div", {
    className: styles.wrapper,
    "data-e2e-name": "ingredients_card",
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx("div", {
        className: styles.card,
        children: children
      })
    })
  });
};